

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const SubscriptionFeesSection = () => {
  return (
    <div>
      <Paragraph>
        Customer agrees to pay the subscription fees and other charges described in
        this Agreement in exchange for access to the TrackBiz software platform.
      </Paragraph>

      <Paragraph>
        <Text strong>Current Pricing</Text>
      </Paragraph>

      <ul>
        <li>TrackBiz Monthly Subscription: $34.00 per month</li>
        <li>Stripe Card Reader Hardware: $77.94 (one-time charge)</li>
      </ul>

      <Paragraph>
        Subscription fees will be billed automatically through the payment method
        maintained on file with Provider's payment processor.
      </Paragraph>

      <Alert
        message="Non-Refundable Fees"
        description="All subscription fees and hardware charges are non-refundable except as required by applicable law."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Hardware purchases are separate from subscription fees. Customer is
        responsible for the cost of any hardware purchased on Customer's behalf,
        including but not limited to:
      </Paragraph>

      <ul>
        <li>Card Readers</li>
        <li>Receipt Printers</li>
        <li>Barcode Scanners</li>
        <li>Cash Drawers</li>
        <li>Tablets</li>
        <li>Other Business Equipment</li>
      </ul>

      <Paragraph>
        Hardware fees become due immediately upon purchase and are non-refundable
        once the order has been placed with the hardware supplier.
      </Paragraph>

      <Paragraph>
        Provider may modify subscription pricing for future billing periods by
        providing Customer with at least thirty (30) days advance notice.
      </Paragraph>
    </div>
  );
};

export default SubscriptionFeesSection;